import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'

import { changePassword, getSettings, setSettings } from './api/api'
import { settingsKey } from './keyFactory'
import type { ChangePasswordInput, UserSettings } from './types'

export function useSettings() {
  return useQuery({ queryKey: settingsKey(), queryFn: getSettings })
}

export function useUpdateSettings() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (input: UserSettings) => setSettings(input),
    onSuccess: (settings) => queryClient.setQueryData(settingsKey(), settings),
  })
}

export function useChangePassword() {
  return useMutation({
    mutationFn: (input: ChangePasswordInput) => changePassword(input),
  })
}
